module.exports = __webpack_public_path__ + "img/left.181fcae4.png";